function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "b",
    width: 982.61,
    height: 179.45,
    viewBox: "0 0 982.61 179.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m177.12,7.3c-5.73,9.29-12.5,17.58-20.73,24.87-24.14,20.23-56.08,34.36-86.67,41.27-2.84.62-5.69,1.17-8.56,1.64,11.36,0,22.64-.47,33.98-.66,12.33-.72,33.72-2.24,36.99,13.74,1.89,9.28-2.33,19.28-6.94,27.1-14.25,23.09-38.65,37.03-64.82,41.53-1.02.18-.84,1.68.19,1.62,4.6-.26,9.18-.81,13.75-1.63,32.83-6.86,58.03-26.75,76.26-54.39,17.42-28.34,26.36-61.49,28.06-94.62.04-.84-1.07-1.19-1.51-.47Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m820.93,2.02c-8.52,0-14.36,6.01-14.36,14.53s5.85,14.7,14.36,14.7,14.2-6.18,14.2-14.7-6.01-14.53-14.2-14.53Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597.06,149h-2.96c-.82,0-1.48.66-1.48,1.48v25.04c0,.86.64,1.48,1.51,1.48h2.94c.91,0,1.55-.62,1.55-1.48v-25.04c0-.85-.64-1.48-1.55-1.48Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m671.15,149h-5.78c-.62,0-1.19.39-1.39,1.01l-6.86,19.6-6.89-19.6c-.19-.62-.77-1.01-1.39-1.01h-5.76c-.82,0-1.48.66-1.48,1.48v25.52l-.55-.48c0,.86.62,1.48,1.48,1.48h2.52c.91,0,1.55-.62,1.55-1.48v-19.66l7.2,20.13c.24.62.79,1.02,1.47,1.02h2.62c.68,0,1.23-.39,1.47-1.02l7.24-20.13v19.66c0,.86.64,1.48,1.55,1.48h2.99c.89,0,1.46-.62,1.46-1.48v-25.04c0-.85-.58-1.48-1.46-1.48Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m727.94,148.34c-7.39,0-14.38,4.53-14.38,14.62s7,14.62,14.38,14.62,14.38-4.53,14.38-14.62-6.99-14.62-14.38-14.62Zm0,24.47c-4.85,0-8.48-3.75-8.48-9.85s3.63-9.85,8.48-9.85,8.52,3.75,8.52,9.85-3.67,9.85-8.52,9.85Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m805.14,149h-2.88c-.66,0-1.21.39-1.44,1.05l-7.35,20.84-7.31-20.84c-.23-.66-.78-1.05-1.44-1.05h-2.88c-1.28,0-1.87.82-1.44,2.02l9.26,25.01c.23.58.82.97,1.44.97h4.78c.62,0,1.21-.39,1.4-.97l9.29-25.01c.43-1.21-.16-2.02-1.44-2.02Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m868.09,172h-15.48v-7h13.42c.93,0,1.58-.67,1.58-1.6v-1.76c0-.97-.65-1.64-1.58-1.64h-13.42v-6h14.46c.91,0,1.54-.62,1.54-1.56v-1.89c0-.9-.63-1.56-1.54-1.56h-17.98c-.82,0-1.48.66-1.48,1.48v25.52l-.4-.48c0,.86.62,1.48,1.49,1.48h19.3c.95,0,1.61-.66,1.61-1.56v-1.92c0-.84-.68-1.52-1.52-1.52Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m915.06,149h-2.96c-.82,0-1.48.66-1.48,1.48v25.04c0,.86.64,1.48,1.51,1.48h2.94c.91,0,1.55-.62,1.55-1.48v-25.04c0-.85-.64-1.48-1.55-1.48Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m970.52,160.34c-4.49-.78-5.94-2.07-5.94-3.91,0-1.95,1.68-3.32,4.96-3.32,2.77.04,4.1,1.02,4.88,1.84.55.35,1.21.62,1.95.39l2.23-.78c.94-.31,1.33-1.13.74-1.88-1.53-2.23-4.81-4.34-9.93-4.34-6.92,0-10.75,3.24-10.75,8.01,0,4.06,2.46,7.15,10.2,8.6,4.34.78,5.98,1.95,5.98,4.02,0,2.19-1.56,3.83-5.39,3.83-3.56,0-5.16-1.49-6.02-2.46-.35-.35-.78-.59-1.29-.59-.19,0-.39.04-.62.12l-2.34.82c-.9.27-1.25,1.05-.78,1.84,1.48,2.46,4.81,5.04,11.06,5.04,7.39,0,11.29-3.48,11.29-8.56,0-5.35-3.75-7.58-10.24-8.68Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m726.5,145h1.02c.21,0,.41-.09.55-.25l3.91-4.58c.39-.46.07-1.17-.54-1.17h-2.13c-.25,0-.48.13-.61.34l-2.81,4.56c-.29.48.05,1.1.61,1.1Z",
    style: {
      fill: "#ef7d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.07,27.94c-4.6.26-9.19.81-13.75,1.63-32.83,6.87-58.03,26.75-76.25,54.39C10.64,112.31,1.7,145.46,0,178.59c-.04.84,1.07,1.19,1.51.47,5.73-9.29,12.5-17.58,20.73-24.87,24.14-20.23,56.08-34.36,86.67-41.27,2.84-.62,5.69-1.17,8.56-1.64-11.36,0-22.64.47-33.98.66-12.33.72-33.73,2.24-36.99-13.74-1.89-9.28,2.33-19.28,6.94-27.1,14.25-23.09,38.65-37.03,64.82-41.53,1.02-.18.84-1.68-.19-1.62Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.24,6h-51.95c-4.24,0-7.68,3.44-7.68,7.68v105.32l-.13.32c0,4.68,3.01,7.68,7.68,7.68h15.87c4.54,0,7.57-3.03,7.57-7.74v-27.26h28.63c28.05,0,45.86-16.46,45.86-43s-17.64-43-45.86-43Zm-3.52,62h-25.11V31h25.11c12.72,0,18.42,7.53,18.42,18.42s-5.69,18.58-18.42,18.58Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.16,39.6c-29.73,0-48.94,17.7-48.94,44.59s19.21,44.59,48.94,44.59,49.1-17.7,49.1-44.59-19.21-44.59-49.1-44.59Zm0,66.64c-12.36,0-19.37-9.35-19.37-22.05s7.01-22.05,19.37-22.05,19.54,9.35,19.54,22.05-7.02,22.05-19.54,22.05Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.49,108.75c-.84-2.67-3.01-3.67-5.68-3.17-1.5.33-3.34.67-5.18.67-8.52,0-10.02-6.18-10.02-17.04v-25.2h15.32c4.24,0,7.68-3.44,7.68-7.68v-7.54c0-4.73-3.24-7.78-7.84-7.78h-15.16v-15.32c0-4.24-3.44-7.68-7.68-7.68h-13.8c-4.15,0-7.52,3.37-7.52,7.52v15.48h-9.15c-3.23,0-5.85,2.62-5.85,5.85v11.31c0,3.23,2.62,5.85,5.85,5.85h9.15v25l-.4.2c0,24.72,7.85,39.58,33.74,39.58,7.68,0,13.19-1.5,16.54-3.01,2.84-1.17,3.84-4.34,3.01-7.35l-3.01-9.69Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544.53,39.56c-28.56,0-46.6,17.7-46.6,44.59s17.2,44.59,47.27,44.59c17.54,0,29.39-5.85,36.58-11.86,4.18-3.51,2.84-8.35-2.34-10.69l-7.52-3.34c-1-.5-2.17-.67-3.34-.67-1.5,0-3.01.33-4.34,1-3.34,2.34-9.02,5.01-17.54,5.01-13.7,0-18.37-7.68-19.04-16.2h55.45c4.01,0,7.18-2.84,7.18-6.85-.17-29.56-18.87-45.6-45.76-45.6Zm-16.87,38.44c.84-9.35,5.85-17.2,16.87-17.2s16.53,8.02,16.7,17.2h-33.57Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.41,40.33c-14.41,0-21.45,7.33-24.8,13.67v-4.83c0-3.83-3.18-7.17-7.71-7.17h-13.61c-4.24,0-7.68,3.44-7.68,7.68v69.32l-.29.32c0,4.68,3.01,7.68,7.68,7.68h13.99c4.48,0,7.63-3.01,7.63-7.68v-35.74c0-11.69,4.64-20.71,16.08-20.71s14.92,8.69,14.92,20.38v36.08c0,4.24,3.44,7.68,7.68,7.68h14.61c4.53,0,7.71-3,7.71-7.67v-36c0-25.83-9.89-43-36.2-43Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.47,62.15c5.85,0,10.02,2.84,12.69,5.18,2.51,2,5.85,3.51,9.19,2.67l10.19-3.01c4.68-1.34,6.85-5.34,4.34-9.35-6.35-9.85-18.2-18.21-37.24-18.21-29.56,0-47.1,17.87-47.1,44.76s17.54,44.59,47.1,44.59c19.04,0,30.9-8.35,37.24-18.04,2.51-4.18.33-8.02-4.34-9.35l-10.19-3.01c-3.34-.84-6.68.5-9.19,2.67-2.67,2.34-6.85,5.01-12.69,5.01-11.52,0-18.37-8.52-18.37-21.88s6.85-22.05,18.37-22.05Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m827.82,42h-14.52c-4.24,0-7.68,3.44-7.68,7.68v69.65c0,4.67,3.05,7.67,7.8,7.67h14.41c4.58,0,7.8-3,7.8-7.67V49.67c0-4.67-3.22-7.67-7.8-7.67Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m894.09,40.15c-14.99,0-26.69,3.84-34.11,7.35-4.28,2-5.11,6.35-2.64,10.19l3.63,5.51c1.98,3.17,5.44,4.34,8.9,3.17,6.1-2.34,13.02-4.18,20.76-4.18,12.03,0,15.82,4.84,15.98,13.7-21.26-.17-55.53-.17-55.53,27.06,0,16.7,11.7,25.72,31.31,25.72,11.53,0,20.76-5.34,24.22-11.69v4.01c.66,3.17,3.13,6.01,7.58,6.01h14.01c4.45,0,7.41-3.01,7.41-7.68v-38.58c0-24.22-7.25-40.59-41.52-40.59Zm12.52,55.07c0,8.52-5.18,14.86-15.37,14.86-7.52,0-11.52-3.51-11.52-9.19,0-10.19,13.53-11.86,26.89-11.69v6.01Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m974.82,0h-14.52c-4.24,0-7.68,3.44-7.68,7.68v111.63c0,4.68,3.05,7.69,7.8,7.69h14.41c4.58,0,7.8-3.01,7.8-7.69V7.69c0-4.68-3.22-7.69-7.8-7.69Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.76,144.4c-8.55,0-15.49,6.93-15.49,15.49s6.93,15.48,15.49,15.48,15.49-6.93,15.49-15.48-6.93-15.49-15.49-15.49Zm0,28.45c-7.16,0-12.97-5.8-12.97-12.97s5.8-12.97,12.97-12.97,12.97,5.8,12.97,12.97-5.8,12.97-12.97,12.97Z",
    style: {
      fill: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.28,161.41c-.29-.26-.72-.53-1.28-.8,1.54-.21,2.68-.71,3.42-1.49.74-.78,1.11-1.74,1.11-2.88,0-.88-.22-1.69-.67-2.42-.45-.73-1.04-1.24-1.78-1.53-.74-.29-1.83-.43-3.26-.43h-7.12v16.05h2.12v-7.13h2.46c.55,0,.94.03,1.18.08.33.08.65.22.97.43.32.2.68.56,1.08,1.07.4.51.91,1.25,1.53,2.21l2.12,3.34h2.67l-2.79-4.37c-.55-.85-1.14-1.57-1.76-2.14Zm-2.9-2.46h-4.57v-5.31h5.08c1.19,0,2.06.24,2.61.73s.83,1.11.83,1.87c0,.52-.14,1-.43,1.44-.28.44-.7.76-1.25.96-.55.2-1.31.3-2.28.3Z",
    style: {
      fill: "#2B2B2B"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/LogoLogin.2b2383c079b307c51201f44dda9c28c1.svg";
export { ForwardRef as ReactComponent };